var _circle, _mask, _path, _path2, _mask2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1286_13850",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 10,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5,
    y: 3,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82204 15.4176L6.51578 9.70882C6.17795 9.13343 5.99989 8.47827 6 7.81103C6.00058 7.30979 6.09991 6.81358 6.29233 6.35075C6.48475 5.88792 6.76647 5.46754 7.12141 5.11362C7.47635 4.75971 7.89754 4.4792 8.36093 4.28812C8.82431 4.09704 9.32081 3.99914 9.82204 4.00001C10.3974 3.99995 10.9653 4.13025 11.4831 4.38113C12.001 4.63201 12.4552 4.99694 12.8118 5.44853C13.1683 5.90012 13.4179 6.42662 13.5418 6.98849C13.6658 7.55037 13.6608 8.13302 13.5273 8.6927C13.4394 9.04912 13.3014 9.39124 13.1173 9.70882L9.82204 15.4176Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82204 15.4176L6.51578 9.70882C6.17795 9.13343 5.99989 8.47827 6 7.81103C6.00058 7.30979 6.09991 6.81358 6.29233 6.35075C6.48475 5.88792 6.76647 5.46754 7.12141 5.11362C7.47635 4.75971 7.89754 4.4792 8.36093 4.28812C8.82431 4.09704 9.32081 3.99914 9.82204 4.00001C10.3974 3.99995 10.9653 4.13025 11.4831 4.38113C12.001 4.63201 12.4552 4.99694 12.8118 5.44853C13.1683 5.90012 13.4179 6.42662 13.5418 6.98849C13.6658 7.55037 13.6608 8.13302 13.5273 8.6927C13.4394 9.04912 13.3014 9.39124 13.1173 9.70882L9.82204 15.4176Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82204 15.4176L6.51578 9.70882C6.17795 9.13343 5.99989 8.47827 6 7.81103C6.00058 7.30979 6.09991 6.81358 6.29233 6.35075C6.48475 5.88792 6.76647 5.46754 7.12141 5.11362C7.47635 4.75971 7.89754 4.4792 8.36093 4.28812C8.82431 4.09704 9.32081 3.99914 9.82204 4.00001C10.3974 3.99995 10.9653 4.13025 11.4831 4.38113C12.001 4.63201 12.4552 4.99694 12.8118 5.44853C13.1683 5.90012 13.4179 6.42662 13.5418 6.98849C13.6658 7.55037 13.6608 8.13302 13.5273 8.6927C13.4394 9.04912 13.3014 9.39124 13.1173 9.70882L9.82204 15.4176Z",
    stroke: "black",
    mask: "url(#path-2-outside-1_1286_13850)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2_1286_13850",
    maskUnits: "userSpaceOnUse",
    x: 6.33008,
    y: 4.23047,
    width: 7,
    height: 7,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6.33008,
    y: 4.23047,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34345 9.72254C8.77099 10.0402 9.28981 10.2111 9.82245 10.2097C10.4825 10.2091 11.1153 9.94678 11.5822 9.48029C12.0491 9.01379 12.312 8.38117 12.3132 7.72115C12.3133 7.20203 12.1498 6.69607 11.8459 6.27521C11.5863 5.91122 11.2339 5.6235 10.8254 5.44203C10.4003 5.25469 9.93131 5.18994 9.47139 5.2551C9.01147 5.32026 8.57894 5.51274 8.22265 5.81079C7.86637 6.10884 7.60053 6.50059 7.45517 6.94177C7.30981 7.38296 7.29072 7.856 7.40006 8.30746C7.43258 8.44258 7.47683 8.57459 7.53231 8.70201C7.70793 9.10778 7.98778 9.45988 8.34345 9.72254Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34345 9.72254C8.77099 10.0402 9.28981 10.2111 9.82245 10.2097C10.4825 10.2091 11.1153 9.94678 11.5822 9.48029C12.0491 9.01379 12.312 8.38117 12.3132 7.72115C12.3133 7.20203 12.1498 6.69607 11.8459 6.27521C11.5863 5.91122 11.2339 5.6235 10.8254 5.44203C10.4003 5.25469 9.93131 5.18994 9.47139 5.2551C9.01147 5.32026 8.57894 5.51274 8.22265 5.81079C7.86637 6.10884 7.60053 6.50059 7.45517 6.94177C7.30981 7.38296 7.29072 7.856 7.40006 8.30746C7.43258 8.44258 7.47683 8.57459 7.53231 8.70201C7.70793 9.10778 7.98778 9.45988 8.34345 9.72254Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34345 9.72254C8.77099 10.0402 9.28981 10.2111 9.82245 10.2097C10.4825 10.2091 11.1153 9.94678 11.5822 9.48029C12.0491 9.01379 12.312 8.38117 12.3132 7.72115C12.3133 7.20203 12.1498 6.69607 11.8459 6.27521C11.5863 5.91122 11.2339 5.6235 10.8254 5.44203C10.4003 5.25469 9.93131 5.18994 9.47139 5.2551C9.01147 5.32026 8.57894 5.51274 8.22265 5.81079C7.86637 6.10884 7.60053 6.50059 7.45517 6.94177C7.30981 7.38296 7.29072 7.856 7.40006 8.30746C7.43258 8.44258 7.47683 8.57459 7.53231 8.70201C7.70793 9.10778 7.98778 9.45988 8.34345 9.72254Z",
    stroke: "black",
    strokeWidth: 0.4,
    mask: "url(#path-3-outside-2_1286_13850)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFilled);
export default __webpack_public_path__ + "static/media/pin-filled.4a9036e9281deed3c3a53b377e8c21ee.svg";
export { ForwardRef as ReactComponent };